/**
 * Race seed derivation — Plan 08-03 Task 2.
 *
 * 말 배정 (메시지 parse 실패 시 무작위) seed = `${eventId}:assign`.
 * 결승선 도달 (베팅 가중치 기반 winner 결정) seed = `${eventId}:finish`.
 */
import { createSeededRng, type SeededRng } from '../seeded-rng.js';

export function createRaceAssignRng(donationEventId: string): SeededRng {
  return createSeededRng(`${donationEventId}:assign`);
}

export function createRaceFinishRng(donationEventId: string): SeededRng {
  return createSeededRng(`${donationEventId}:finish`);
}
